@if (leadingIcon(); as leadingIcon) {
    <vds-icon [name]="leadingIcon" />
}
<span class="vds-text-link-label">
    <ng-content />
</span>
@if (trailingIcon(); as trailingIcon) {
    <vds-icon [name]="trailingIcon" />
}
<span class="vds-text-link-touch-target"></span>
